import { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Loader2, Inbox } from 'lucide-react';
import { CATEGORY_META, timeAgo } from '../categoryMeta';
import StaffAppItemDetail from '../StaffAppItemDetail';

/** The combined alert feed — everything that needs a staff member's
 * attention, urgent items pinned first (server-sorted already). */
export default function StaffAppFeedPage() {
  const { feed, reloadFeed } = useOutletContext();
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const openItem = (item) => {
    if (item.category === 'message') navigate(`/staff-app/chats/${item.ref_id}`);
    else setSelected(item);
  };

  if (!feed) {
    return (
      <div className="flex items-center justify-center py-20" data-testid="staff-app-feed-loading">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (feed.items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-24 text-center px-6" data-testid="staff-app-feed-empty">
        <Inbox className="w-10 h-10 text-muted-foreground/60" />
        <p className="text-sm font-semibold">All caught up</p>
        <p className="text-xs text-muted-foreground">Nothing needs your attention right now.</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-border" data-testid="staff-app-feed-list">
      {feed.items.map((item) => {
        const meta = CATEGORY_META[item.category] || CATEGORY_META.task;
        const Icon = meta.icon;
        return (
          <button key={item.id} onClick={() => openItem(item)} data-testid={`staff-app-feed-item-${item.id}`}
            className="staff-app-feed-item w-full flex items-start gap-3 px-4 py-3.5 text-left hover:bg-muted/50">
            <span className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center ${meta.cls}`}>
              <Icon className="w-4.5 h-4.5" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-1.5">
                {item.urgent && <span className="staff-app-urgent-dot w-1.5 h-1.5 rounded-full bg-red-600 shrink-0" data-testid={`staff-app-urgent-dot-${item.id}`} />}
                <span className="text-sm font-semibold truncate">{item.title}</span>
              </span>
              <span className="block text-xs text-muted-foreground truncate mt-0.5">{item.subtitle}</span>
            </span>
            <span className="shrink-0 text-[11px] text-muted-foreground mt-0.5">{timeAgo(item.created_at)}</span>
          </button>
        );
      })}
      <StaffAppItemDetail item={selected} onClose={() => setSelected(null)} onActed={reloadFeed} />
    </div>
  );
}
